import { _animate } from "../utils/_animate";
import { _downloadBtn } from "../utils/_downloadBtn";
import { _lazyLoad } from "../utils/_lazyLoad";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

class CaseStudyExperience extends MainClass {
    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.init();
    }

    init() {
        // for lazyload
        _lazyLoad();

        // for animate
        new _animate();

        // for download btns
        _downloadBtn();

        // console.log("CaseStudyExperience", this);
    }
}

export default CaseStudyExperience;
